import { IApiSessionEmailExpandReq, IApiSubMessageDto } from '@/services/swagger/easourcing/models';
import { SubContentType, UserRetryAskSubMsg } from '../../types';
import { ChevronRight } from 'lucide-react';
import React, { PropsWithChildren, useMemo, useState } from 'react';
import { InquiryPreviewDialogV2 } from '@/components/inquiry-dialog/InquiryPreviewDialog';
import { useRequest } from 'ahooks';
import { inquiryAskPost } from '@/services/swagger/easourcing/SessionService';
import { ProductInfo } from '@/components/inquiry-dialog/types';
import { LabelTag } from '../base/label-tag';
import { EmailPreviewDialog } from '@/features/supplier-agent';

/**
 * 用户消息文本组件
 * @param param0
 * @returns
 */
export const UserText: React.FC<PropsWithChildren<unknown>> = props => {
  const { children } = props;
  return (
    <div
      style={{
        wordBreak: 'break-word',
      }}
      className="inline-flex min-h-[48px] py-3  max-w-5/6 justify-center items-center  border [background:linear-gradient(91deg,#F0FFF9_10.06%,#FEFEF0_105.19%)] px-4 rounded-[24px_24px_4px_24px] border-solid border-[#E3F7EF]
    text-[color:var(--950-fill-,#09090B)]  [font-family:Geist]  font-normal leading-[150%]
 break-words
    "
    >
      {children}
    </div>
  );
};
export const UserNormalText: React.FC<{
  subMsg: IApiSubMessageDto;
  sessionId: string;
}> = ({ subMsg, sessionId }) => {
  const text = subMsg.contentValue.text;
  const [inquiryPreviewOpen, setInquiryPreviewOpen] = useState(false);
  const [emailPreviewOpen, setEmailPreviewOpen] = useState(false);

  const { data, run } = useRequest(
    () => {
      return inquiryAskPost({
        subMessageId: subMsg.subMessageId,
      }).then(res => res.data);
    },
    {
      manual: true,
    }
  );
  const productInfo = useMemo<ProductInfo>(() => {
    if (data) {
      return {
        ...data,
        specifications: data.specification,
      };
    }
    return {} as ProductInfo;
  }, [data]);

  const headerEl = useMemo(() => {
    const subMsgV2 = subMsg as UserRetryAskSubMsg;
    if (subMsgV2.contentType === SubContentType.emailRetryAsk) {
      return (
        <LabelTag
          className="mb-1"
          text={subMsgV2.contentValue.originEmailSubject}
          onClick={() => {
            setEmailPreviewOpen(true);
          }}
        />
      );
    }
    return null;
  }, [subMsg]);
  const emailExpandParams = useMemo<Required<IApiSessionEmailExpandReq>>(() => {
    const subMsgV2 = subMsg as UserRetryAskSubMsg;
    return {
      messageId: subMsgV2.contentValue.originMessageId,
      subMessageId: subMsgV2.contentValue.originSubMessageId,
      sessionId: sessionId,
    };
  }, [subMsg, sessionId]);

  return (
    <React.Fragment>
      <div className="flex justify-end">
        <UserText>
          <div className=" max-w-full">
            {headerEl}
            {text}
          </div>
        </UserText>
      </div>
      {subMsg.contentType === SubContentType.inquiryAsk ? (
        <div className="flex justify-end">
          <div
            className=" inline-flex items-center justify-center rounded-[8px] mt-2 cursor-pointer  bg-[#F5F5F5] h-[30px] px-3 text-[#525252]"
            onClick={() => {
              setInquiryPreviewOpen(true);
              run();
            }}
          >
            View inquiry details <ChevronRight size={16} />
          </div>
        </div>
      ) : null}

      <InquiryPreviewDialogV2
        open={inquiryPreviewOpen}
        onOpenChange={() => setInquiryPreviewOpen(false)}
        productInfo={productInfo}
      />
      <EmailPreviewDialog
        open={emailPreviewOpen}
        onOpenChange={() => setEmailPreviewOpen(false)}
        emailExpandParams={emailExpandParams}
        disableButton={true}
        onMinimize={() => setEmailPreviewOpen(false)}
      />
    </React.Fragment>
  );
};
